import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CommentTextareaBody from './commentTextareaBody';
import CommentTextareaBottom from './commentTextareaBottom';

class CommentTextarea extends PureComponent {
    static propTypes = {
        loginId: PropTypes.string,
        config: PropTypes.object,
        userInfo: PropTypes.object,
        myComUrl: PropTypes.string,
    };

    render() {
        const { loginId, config, userInfo, myComUrl } = this.props;

        return (
            <div>
                <CommentTextareaBody loginId={loginId} config={config} userInfo={userInfo} />
                <CommentTextareaBottom loginId={loginId} userInfo={userInfo} myComUrl={myComUrl} />
            </div>
        );
    }
}

export default CommentTextarea;
